import * as HoverCard from '@radix-ui/react-hover-card'
import { Routes } from '@scalis/routes'
import { HoverButton } from '../hover-button/hover-button'
import { ListItem } from './components/list-item'

export const ResourcesMenu = () => {
  return (
    <HoverCard.Root
      openDelay={0}
      closeDelay={0}
    >
      <HoverCard.Trigger asChild>
        <HoverButton text='Resources' />
      </HoverCard.Trigger>
      <HoverCard.Portal>
        <HoverCard.Content align='start'>
          <div className='pt-1'>
            <ul className='bg-neutral-00 p-2 border border-neutral-00 rounded-xl'>
              <li className='w-40'>
                <ListItem
                  icon='fa-regular fa-newspaper'
                  text='Articles'
                  href={Routes.blog.articles}
                />
              </li>
              {/* <li className='w-40'>
                <ListItem
                  icon='fa-regular fa-book'
                  text='Case Studies'
                  href={Routes.blog.caseStudies}
                />
              </li>
              <li className='w-40'>
                <ListItem
                  icon='fa-regular fa-bolt'
                  text='Integrations'
                  href={Routes.blog.integrations}
                />
              </li> */}
            </ul>
          </div>
        </HoverCard.Content>
      </HoverCard.Portal>
    </HoverCard.Root>
  )
}
